module.exports = __webpack_public_path__ + "img/pinganyunecs-black.2ff2c7d9.svg";